import { actualizarSiteSetting, obtenerSiteSettingsMap } from "./siteSettingsService";
import { obtenerSiteMediaMap } from "@/services/siteMedia/siteMediaService";
import { getSiteMediaFallback } from "@/data/siteMediaFallbacks";

const KEY = "alojamiento.content";
const DEFAULT_CONTENT = {
  "heroTitle": "Servicios",
  "heroSubtitle": "Ofrecemos alojamiento y comodidades para la familia bochófila",
  "heroImage": getSiteMediaFallback("alojamiento.hero"),
  "casaFeatures": [
    "52 camas en habitaciones dobles y triples con baños privados.",
    "Salón Comedor con televisión por cable.",
    "Sala para reuniones y/o conferencias.",
    "Cochera con capacidad para 12 vehículos.",
    "Sala de estar con cocina anexa.",
    "Cocina con vajilla completa y freezer.",
    "Acceso a asador.",
    "Lavadero.",
    "Biblioteca.",
    "Calefacción central.",
    "Ventiladores de techo en habitaciones y salas.",
    "Atención personalizada.",
    "Servicio de Remisse."
  ],
  "albergueFeatures": [
    "Sala de estar con cocina anexa.",
    "Cocina con vajilla y freezer.",
    "Acceso a asador.",
    "Lavadero.",
    "Biblioteca.",
    "Ventiladores de techo en habitaciones y sala.",
    "Calefacción central en habitaciones y sala.",
    "Televisión por Cable.",
    "Servicio de Remis."
  ],
  "requirements": [
    "Pertenecer a familia bochófila.",
    "Familia de bajos recursos.",
    "Exclusivamente con fines de estudio.",
    "El beneficio es abonado hasta la finalización del cursado de su carrera original.",
    "Una vez terminado de cursar la carrera, tendrá (1) un año de gracia, para que pueda rendir las materias que le quedaran pendientes a realizar la tesis.",
    "Se le otorgará una habitación en el sector de la calle Suipacha para compartir con personas en igual situación a la de él.",
    "Deberá mantener normas de muy buena conducta y responsabilidad.",
    "Estarán encargados de la limpieza de sus habitaciones, sala de estar y cocina-comedor. (Sector Suipacha).",
    "Abandonará su estudio un monto justificado anualmente por el Consejo Directivo.",
    "Dicha arancel deberá ser abonado por mes anticipado.",
    "Tienen la obligación de colaborar cuándo se los requiera a Delegados en las Reuniones Mensuales.",
    "La falta de cumplimiento en el pago o en el cumplimiento de las obligaciones, el Consejo Directivo de la Federación de Bochas de la Provincia de Córdoba, tiene el derecho de rescindir automáticamente la estadía."
  ],
  "sectionLabel": "Alojamiento",
  "casaTitle": "Casa del Bochófilo",
  "casaFeaturesTitle": "Comodidades",
  "casaPricesTitle": "Precios",
  "priceNote": "* Tarifa sujeta a disponibilidad y temporada.",
  "parkingPrice": "* PRECIO DE COCHERA: $15.000",
  "albergueTitle": "Albergue Estudiantil",
  "albergueFeaturesTitle": "Comodidades",
  "applicationTitle": "Presentación de Solicitud",
  "applicationText": "La solicitud de ingreso se canaliza exclusivamente a través de las Asociaciones en forma oficial y por nota, las cuáles son tratadas en la última reunión de cada año y en caso de ser aprobadas se hace efectivo el ingreso al año siguiente.",
  "requirementsTitle": "Requisitos y obligaciones",
  "alberguePricesTitle": "Precios",
  "alberguePrice": "Residentes Estudiantiles: $6000 por mes.",
  "contactTitle": "Contacto",
  "address": "Buines 1548 (frente), Suipacha 1549 (fondo)",
  "neighborhood": "Barrio Pueyrredón",
  "city": "Ciudad de Córdoba (Argentina)",
  "phones": "Tel: 0351-4221928 / 0351-4231440",
  "fax": "Fax: 0351 / 4221928",
  "casaImages": [],
  "albergueImages": [],
  "preciosCasa": [
    {
      "titulo": "Bochófilos",
      "items": [
        {
          "label": "Habitaciones Comunes",
          "valor": "$80.000"
        },
        {
          "label": "Habitaciones Vip",
          "valor": "$80.000"
        }
      ]
    },
    {
      "titulo": "Bochófilos por enfermedad",
      "items": [
        {
          "label": "Habitaciones Comunes",
          "valor": "$80.000"
        },
        {
          "label": "Habitaciones Vip",
          "valor": "$80.000"
        }
      ]
    },
    {
      "titulo": "Particulares",
      "items": [
        {
          "label": "Habitaciones Comunes",
          "valor": "$80.000"
        },
        {
          "label": "Habitaciones Vip",
          "valor": "$80.000"
        }
      ]
    }
  ],
  "casaDescription": "La Casa del Bochófilo es el punto de encuentro para toda la comunidad bochófila de la provincia. Un espacio dónde se homenajea a los grandes referentes del deporte, se reúnen los jugadores y se planifican las actividades federativas.",
  "albergueDescription": "El Albergue Estudiantil de la Federación de Bochas de Córdoba ofrece hospedaje cómodo y accesible para estudiantes, jugadores y familias que lleguen a la ciudad por competencias, entrenamientos o actividades académicas relacionadas con el deporte."
};

export const alojamientoSections = [
  {
    label: "Portada",
    fields: [
      {"key":"sectionLabel","label":"Etiqueta de sección","type":"text"},
      {"key":"heroTitle","label":"Título","type":"text"},
      {"key":"heroSubtitle","label":"Subtítulo","type":"textarea"},
    ],
  },
  {
    label: "Casa del Bochófilo",
    fields: [
      {"key":"casaTitle","label":"Nombre","type":"text"},
      {"key":"casaDescription","label":"Descripción","type":"textarea"},
      {"key":"casaFeaturesTitle","label":"Título de comodidades","type":"text"},
      {"key":"casaFeatures","label":"Comodidades","type":"list"},
      {"key":"casaImages","label":"Galería","type":"images"},
      {"key":"casaPricesTitle","label":"Título de tarifas","type":"text"},
      {"key":"preciosCasa","label":"Tarifas","type":"prices"},
      {"key":"priceNote","label":"Nota sobre tarifas","type":"text"},
      {"key":"parkingPrice","label":"Tarifa de cochera","type":"text"},
    ],
  },
  {
    label: "Albergue Estudiantil",
    fields: [
      {"key":"albergueTitle","label":"Nombre","type":"text"},
      {"key":"albergueDescription","label":"Descripción","type":"textarea"},
      {"key":"albergueFeaturesTitle","label":"Título de comodidades","type":"text"},
      {"key":"albergueFeatures","label":"Comodidades","type":"list"},
      {"key":"albergueImages","label":"Galería","type":"images"},
      {"key":"applicationTitle","label":"Título de solicitud","type":"text"},
      {"key":"applicationText","label":"Solicitud de ingreso","type":"textarea"},
      {"key":"requirementsTitle","label":"Título de requisitos","type":"text"},
      {"key":"requirements","label":"Requisitos y obligaciones","type":"list"},
      {"key":"alberguePricesTitle","label":"Título de tarifas","type":"text"},
      {"key":"alberguePrice","label":"Tarifa","type":"text"},
    ],
  },
  {
    label: "Contacto",
    fields: [
      {"key":"contactTitle","label":"Título","type":"text"},
      {"key":"address","label":"Dirección","type":"text"},
      {"key":"neighborhood","label":"Barrio","type":"text"},
      {"key":"city","label":"Ciudad","type":"text"},
      {"key":"phones","label":"Teléfonos","type":"text"},
      {"key":"fax","label":"Fax","type":"text"},
    ],
  },
];

export function crearAlojamientoContent() {
  return JSON.parse(JSON.stringify(DEFAULT_CONTENT));
}

export async function obtenerAlojamientoContent() {
  const settings = await obtenerSiteSettingsMap();
  const content = crearAlojamientoContent();
  if (settings[KEY]) {
    const saved = JSON.parse(settings[KEY]);
    if (!saved || typeof saved !== "object" || Array.isArray(saved)) throw new Error("Contenido inválido");
    for (const key of Object.keys(content)) {
      if (!(key in saved)) continue;
      const valid = key === "preciosCasa"
        ? Array.isArray(saved[key]) && saved[key].every(price =>
          price && typeof price.titulo === "string" && Array.isArray(price.items) &&
          price.items.every(item => item && typeof item.label === "string" && typeof item.valor === "string"))
        : Array.isArray(content[key])
          ? Array.isArray(saved[key]) && saved[key].every(value => typeof value === "string")
          : typeof saved[key] === "string";
      if (!valid) throw new Error("Contenido inválido");
      content[key] = saved[key];
    }
  }

  const media = await obtenerSiteMediaMap();
  const hero = media["alojamiento.hero"];
  if (hero?.imageUrl) content.heroImage = hero.imageUrl;

  return content;
}

export async function guardarAlojamientoContent(content) {
  const value = JSON.stringify(content);
  if (new TextEncoder().encode(value).length > 65000) {
    throw new Error("El contenido es demasiado extenso. Reducí los textos o la cantidad de imágenes.");
  }
  return actualizarSiteSetting(KEY, {
    label: "Alojamiento",
    group: "alojamiento",
    value,
  });
}
